import { useForm } from "react-hook-form";
import { PostStoryInput, postStoryInputSchema } from "../zod/PostStory";
import { zodResolver } from "@hookform/resolvers/zod";
import { createStory } from "../../../api/story";
import { useAppState } from "../../../stores/appContext";
import { useState } from "react";
import { showToast } from "@twioku/common_components";
import { COMMON_ERROR_MESSAGE } from "../../../libs/constants";

export const useStoryPost = () => {
    const state = useAppState();
    const { csrfToken } = state;
    const [isSubmitting, setIsSubmitting] = useState(false);
    const form = useForm<PostStoryInput>({
        mode: "onChange",
        resolver: zodResolver(postStoryInputSchema),
        defaultValues: {
            handleName: "",
            title: "",
            body: "",
        },
    });

    const handleSubmit = async (data: PostStoryInput) => {
        const isValid = form.formState.isValid;
        if (!isValid) return;

        setIsSubmitting(true);

        try {
            await createStory(
                {
                    handleName: data.handleName,
                    title: data.title,
                    body: data.body,
                },
                csrfToken
            );
            showToast("ストーリーを投稿しました。");
        } catch (err) {
            console.error(err);
            showToast(COMMON_ERROR_MESSAGE, "error");
        } finally {
            setIsSubmitting(false);
        }
    };

    const onSubmit = form.handleSubmit(handleSubmit);

    const errors = form.formState.errors;

    return {
        control: form.control,
        errors,
        onSubmit,
        isSubmitting,
    };
};
